import { render } from "./p-search-screen.vue?vue&type=template&id=77fe8c9b&scoped=true"
import script from "./p-search-screen.vue?vue&type=script&lang=js"
export * from "./p-search-screen.vue?vue&type=script&lang=js"

import "./p-search-screen.vue?vue&type=style&index=0&id=77fe8c9b&scoped=true&lang=scss"
import "./p-search-screen.vue?vue&type=style&index=1&id=77fe8c9b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fe8c9b"]])

export default __exports__